import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import ArrowRightIcon from "@mui/icons-material/ArrowRightAlt";
import { Typography, Box, Button } from "@mui/material";
import DualListItem from "./DualListItem";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    background: theme.palette.background.default,
    maxHeight: theme.spacing(80),
    minHeight: theme.spacing(50),
    height: "100%",
    display: "flex",
    flexDirection: "column"
  }
}));

const getDualListItem = (item, disabled, onAddToSelectedList) => {
  return (
    <DualListItem
      key={item.id}
      details={item}
      icon={<ArrowRightIcon />}
      onAction={() => onAddToSelectedList(item)}
      disabled={disabled}
    />
  );
};

const UnselectedList = ({
  items,
  onAddToSelectedList,
  onAddAll,
  header,
  listAction,
  hideAddAllButton,
  disabled,
  renderList
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const listTopRef = useRef();
  const [itemWasMoved, setItemWasMoved] = useState(false);

  const handleAddToSelectedList = index => item => {
    setItemWasMoved(true);
    onAddToSelectedList(item, index);
  };
  useEffect(() => {
    if (itemWasMoved) {
      setItemWasMoved(false);
    } else {
      listTopRef && listTopRef.current && listTopRef.current.scrollTo(0, 0);
    }
  }, [items]);

  return (
    <div className={classes.root} data-qa="unselected-list">
      <Typography variant="h5">{header}</Typography>
      {renderList ? (
        renderList(
          items,
          (item, index) =>
            getDualListItem(item, disabled, handleAddToSelectedList(index)),
          listTopRef
        )
      ) : (
        <Box flex="1" overflow="auto" mt={3} ref={listTopRef}>
          {items.map((item, index) =>
            getDualListItem(item, disabled, handleAddToSelectedList(index))
          )}
        </Box>
      )}
      <Box display="flex" justifyContent="space-between" mt={3}>
        <div>{listAction}</div>
        {!hideAddAllButton && (
          <Button
            color="primary"
            onClick={onAddAll}
            disabled={disabled}
            data-qa="unselected-list-add-all-btn"
          >
            {t("dualList.addAllBtn")}
          </Button>
        )}
      </Box>
    </div>
  );
};

UnselectedList.propTypes = {
  items: PropTypes.array,
  onAddToSelectedList: PropTypes.func.isRequired,
  onAddAll: PropTypes.func.isRequired,
  header: PropTypes.string,
  hideAddAllButton: PropTypes.bool,
  disabled: PropTypes.bool
};

UnselectedList.defaultProps = {
  items: []
};

export default UnselectedList;
